import './sortDropdown.scss';
import React from 'react';
import {Option, SelectOnChange} from '../select/select';
import {HibuSelect} from '../select/hibuSelect';

type InputProps = {
    id: string;
    onChange?: SelectOnChange;
    value?: Option;
    options?: Option[];
};

export const SortDropdown = React.memo((props: InputProps) => {
    return (
        <div id={props.id} className="sort-dropdown">
            <HibuSelect
                id={props.id + '-sort-by'}
                name="sortBy"
                value={props.value}
                onChange={props.onChange}
                options={props.options}
            />
        </div>
    );
});
